/**
 * @file: feedThreadTitle.ts
 *
 * Display title for a feed thread, derived from its scope (and order meta).
 * Single source shared by the feed list page, the inbox navigation wiring,
 * and the desktop detail pane header.
 */

import { FeedThreadInboxItem, FeedThreadScope } from '@euler/model/feed';

export function feedThreadTitle(t: FeedThreadInboxItem): string {
  switch (t.scope) {
    case FeedThreadScope.System:
      return '系统通知';
    case FeedThreadScope.MaintenancePlans:
      return '保养提醒';
    case FeedThreadScope.MarketingFollowup:
      return '营销跟进';
    case FeedThreadScope.Leads:
      return '商机提醒';
    case FeedThreadScope.Rewards:
      return '我的账户';
    case FeedThreadScope.Order: {
      const meta = (t.meta ?? null) as {
        scope: FeedThreadScope.Order;
        licensePlateNo?: string;
        orderNo?: string;
      } | null;
      return meta?.licensePlateNo ?? `工单 ${meta?.orderNo ?? ''}`.trim();
    }
  }
}
